export const apiUrl = "https://api.gas-up.co";
// export const apiUrl = "https://3fh9zqrw-4002.inc1.devtunnels.ms";
// live 1

export const s3Url = "https://gasup-bucket-dev.s3.us-east-2.amazonaws.com";
export const webLinkFrontend = "";

export const BaseURL = (link) => {
  return `${apiUrl}/api/v1/${link}`;
};

export const imageUrl = (url) => {
  const result = url?.indexOf("http");
  const imageRenderUrl = result == -1 ? `${s3Url}/${url}` : url;
  return imageRenderUrl;
};
export const mediaUrl = (url) => `${s3Url}/${url}`;
